import { useEffect, useState, useMemo } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    moneda: "",
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    totalLinea: 0.00,
    fecha: new Date
}
const modeloDatosc = {
    clienteID: 0,
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo: ""


}

var SubTotal = 0.00;
var totalDescuento = 0.00;
var totalITBIS = 0.00;
var totalPago = 0.00;
var impresion = '';
var Leatendio = '';

const ImpresionFactura = () => {
    let { Pedido } = useParams();
   
    let emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;
    let us = JSON.parse(localStorage.getItem("sesion_usuario")).correo;
    const [imageSrc, setImageSrc] = useState("");

    const [ListadoLineas, SetListadoLineas] = useState([modeloDatos1]);
    const [Listado, SetListado] = useState([modeloDatos]);
    const [ListadoClientes, SetListadoClientes] = useState([modeloDatosc]);
    const [Empresa, SetEmpresa] = useState([]);
    const [SN, SetSN] = useState();
    const [VerFactura, SetVerFactura] = useState(true);
    const [Copia, SetCopia] = useState(true);
    const [VerImprimir, SetVerImprimir] = useState(false);
    const [printMode, setPrintMode] = useState('a4');


    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + emp);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

    useEffect(() => {
        obtenerDatos(Pedido)
        fetchImage()
        
    }, [])

    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.secuenciaID == parseInt(e)).map(x => x.descripcion);
            SetSN(d)
        }
    }

    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasID/"+ parseInt(e));
        if (response.ok) {
            let data = await response.json();
            SetListado(data[0])
           
            obtenerDatosLineas(data[0].facturaID)
            obtenerDatosClientes(data[0].clienteID)
            obtenerDatosEmpresa(data[0].empresaID)
            obtenerDatosSN(data[0].tipoComprobante)
            obtenerUsuarios(us)

            var subt = data[0].subTotal;
            SubTotal = currencyFormatter({
                currency: "USD",
               value: subt
            })
        }
    }

    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineasF/" + pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)

       
        }
    }

    const obtenerDatosClientes = async (c) => {
        let response = await fetch(Api + "VentasMantenimiento/ListaClientesID/"+ c);

        if (response.ok) {
            let data = await response.json()
         SetListadoClientes(data[0])
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == e).map(e => e)
            SetEmpresa(d[0])
        }
    }

    const obtenerUsuarios = async (u) => {
        let response = await fetch(Api + "usuario/Lista/1");

        if (response.ok) {
            let data = await response.json()
            let fd = data.filter(x => x.correo == u).map(x => x)
            if (u != 'admin@gmail.com') {
          impresion = fd[0].impresionPuntoVenta;
          Leatendio = fd[0].nombre;
            }
            SetVerFactura(false)
        }
    }

   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
        
        SetVerImprimir(true)
        window.print();
     SetCopia(false)
    }

    const [menuPosition, setMenuPosition] = useState(false);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX,
            y: event.pageY,
        });
    };

    const handleCloseMenu = () => {
        setMenuPosition(false);
    };

    //const dollar = currencyFormatter({
    //    currency: "USD",
    //   Listado.subTotal
    //})
    let company = {
        name: "APATECH",
        rnc: "RNC-00000000",
        address: "Santo Domingo, R.D.",
        phone: "(809) 000-0000",
        email: "ventas@apatech.com.do",
        logoUrl: null, // ej: "/logo.png"
    };
    let meta = {
        number: "0001",
        date: new Date().toISOString().slice(0, 10),
        validityDays: 15,
        paymentTerms: "Contado",
    };
    let client = {
        name: "Cliente de Ejemplo",
        taxId: "000000000",
        contact: "John Doe",
        telEmail: "(809) 111-1111 / cliente@email.com",
        address: "Dirección del cliente",
    };
    let summary = {
        seller: "Vendedor",
        currencyLabel: "DOP",
        deliveryEta: "3-5 días",
        shortNote: "Gracias por su preferencia.",
    };
    let items = [
        // { description, quantity, unit, unitPrice, discountPercent }
        { description: "Servicio/Producto 1", quantity: 1, unit: "unidad", unitPrice: 12345, discountPercent: 0 },
        { description: "Material 2", quantity: 5, unit: "m²", unitPrice: 2000, discountPercent: 5 },
    ];
    let taxRate = 0.18;         // ITBIS 18%
    let currency = "DOP";       // Para Intl.NumberFormat

    const isPosPrint = printMode === 'pos';
    const styles = `
    @page{
      size: ${isPosPrint ? '80mm auto' : 'A4 portrait'};
      margin: ${isPosPrint ? '4mm' : '10mm'};
    }
    :root{
      --primary:#0d6efd; --text:#1f2937; --muted:#6b7280;
      --border:#e5e7eb; --bg:#ffffff; --stripe:#f9fafb;
    }
    *{box-sizing:border-box}
    body{ margin:0; -webkit-print-color-adjust:exact; print-color-adjust:exact; overflow:visible !important; }
    .printArea{ overflow:visible !important; width:100%; }
    .page{ max-width:900px; margin:0 auto; padding:24px; background:#fff; border:1px solid var(--border); border-radius:12px; color:var(--text); font:14px/1.5 system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,'Helvetica Neue',Arial; }
    header{ display:flex; align-items:center; gap:18px; border-bottom:2px solid var(--border); padding-bottom:16px; }
    .logo{ width:90px; height:90px; border:1px dashed var(--border); display:flex; align-items:center; justify-content:center; border-radius:10px; font-weight:700; color:var(--muted); background:linear-gradient(180deg,#fff,#f8fafc); overflow:hidden; }
    .logo img{ width:100%; height:100%; object-fit:contain; }
    .company{ flex:1; }
    .company h1{ margin:0; font-size:22px; letter-spacing:.3px; }
    .company p{ margin:.2rem 0; color:var(--muted); }
    .meta{ text-align:right; min-width:240px; }
    .meta h2{ margin:0; color:var(--primary); font-size:20px; }
    .meta .code{ font-weight:700; }
    .grid{ display:grid; grid-template-columns:1fr 1fr; gap:14px; margin:16px 0 8px; }
    .card{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .card h3{ margin:0 0 6px; font-size:14px; color:#111827; }
    .card p{ margin:.2rem 0; color:var(--muted); }
    table{ width:100%; border-collapse:collapse; margin-top:14px; font-size:13px; border:1px solid var(--border); border-radius:10px; overflow:hidden; table-layout:fixed; }
    thead th{ text-align:left; background:#f3f4f6; color:#111827; font-weight:600; padding:10px; border-bottom:1px solid var(--border); }
    tbody td{ padding:9px 10px; border-bottom:1px solid var(--border); vertical-align:top; word-break:break-word; }
    tbody tr:nth-child(odd){ background:var(--stripe); }
    tfoot td{ padding:8px 10px; border-top:1px solid var(--border); }
    .right{text-align:right}
    .totals{ margin-top:10px; display:grid; grid-template-columns:1fr 320px; gap:12px; align-items:start; }
    .summary{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .summary .row{ display:flex; justify-content:space-between;  border-bottom:1px dashed var(--border);flex-wrap: nowrap; }
    .summary .row:last-child{ border-bottom:none; }
    .summary .row.total{ font-size:16px; font-weight:800; color:#111827; }
    .notes{ margin-top:14px; border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; color:var(--muted); }
    .sign{ display:grid; grid-template-columns:1fr 1fr; gap:18px; margin-top:30px; }
    .sign .line{ border-top:1px solid var(--border); padding-top:8px; text-align:center; color:var(--muted); }
    .actions{ display:flex; gap:8px; justify-content:flex-end; margin-top:10px; }
    .btn{ appearance:none; border:1px solid var(--border); background:#fff; padding:8px 12px; border-radius:8px; cursor:pointer; }
    .btn.primary{ background:var(--primary); border-color:var(--primary); color:#fff; }
    .ticket-page{
      width:72mm;
      margin:0 auto;
      font:12px/1.35 'Courier New', monospace;
      color:#111;
      background:#fff;
      border:1px dashed #d9d9d9;
      padding:8px;
    }
    .ticket-head{ text-align:center; border-bottom:1px dashed #bbb; padding-bottom:6px; margin-bottom:6px; }
    .ticket-logo{ width:58px; height:58px; object-fit:contain; margin:0 auto 4px; display:block; }
    .ticket-company{ font-weight:700; font-size:13px; }
    .ticket-row{ display:flex; justify-content:space-between; gap:8px; }
    .ticket-items{ width:100%; border-collapse:collapse; margin-top:6px; }
    .ticket-items th,.ticket-items td{ border:0; padding:3px 0; font-size:11px; }
    .ticket-items th{ border-bottom:1px dashed #bbb; font-weight:700; }
    .ticket-items td:last-child,.ticket-items th:last-child{ text-align:right; }
    .ticket-totals{ margin-top:8px; border-top:1px dashed #bbb; padding-top:6px; }
    .ticket-total-line{ display:flex; justify-content:space-between; }
    .ticket-total-final{ font-weight:700; font-size:13px; border-top:1px dashed #bbb; margin-top:4px; padding-top:4px; }
    .ticket-footer{ text-align:center; margin-top:8px; border-top:1px dashed #bbb; padding-top:6px; font-size:11px; }
    @media print{
      html, body{ overflow:visible !important; height:auto !important; }
      .printArea{ margin:0 !important; overflow:visible !important; }
      .page, .ticket-page{ border:none; border-radius:0; padding:0; margin:0; max-width:100%; width:100%; }
      .actions{ display:none !important; }
      thead{ display:table-header-group; }
      tbody{ display:table-row-group; }
      tr, td, th, .card, .summary, .notes{ page-break-inside:avoid; break-inside:avoid; }
    }
  `;

    //const money = (v) =>

    //new Intl.NumberFormat("es-DO", { style: "currency", currency }).format(
    //    Number.isFinite(+v) ? +v : 0
    //);
    const money = (v) => {

        let locale = "es-DO"
   
   
        const n = Number.isFinite(+v) ? +v : 0;
 
        let out = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "USD",
            currencyDisplay: "symbol", // a veces algunos locales rinden "US$"
        }).format(n);
        // Quita cualquier “US$” o “USD ” que pudiera aparecer
        out = out.replace(/US\$\s?/i, Listado.moneda + "$");
        return out.trim();
         
    };

const { subtotal, discountTotal, tax, total } = useMemo(() => {
    let sub = 0;
    let discount = 0;
    for (const it of items) {
        const qty = Number(it.quantity || 0);
        const price = Number(it.unitPrice || 0);
        const disc = Number(it.discountPercent || 0);
        const line = qty * price;
        const lineDisc = (line * disc) / 100;
        sub += line - lineDisc;
        discount += lineDisc;
    }
    const tx = +(sub * taxRate).toFixed(2);
    const tot = +(sub + tx).toFixed(2);
    return { subtotal: +sub.toFixed(2), discountTotal: +discount.toFixed(2), tax: tx, total: tot };
}, [items, taxRate]);

const percentLabel = `${Math.round(taxRate * 100)}%`;

    return (
        <>
      <div onContextMenu={handleContextMenu}   >
            <div className="printArea" style={{ backgroundColor: "none", marginLeft: "0px", marginTop: "0px" }}>
                <style>{styles}</style>
               
                <div className="page">
                    <div className="actions">
                        <select value={printMode} onChange={(e) => setPrintMode(e.target.value)} className="btn" style={{ minWidth: 180 }}>
                            <option value="a4">Formato A4</option>
                            <option value="pos">Punto de venta (80mm)</option>
                        </select>
                        <button className="btn" onClick={() => Imprimir()}>Imprimir</button>
                    </div>
                    {printMode === 'a4' && (
                    <>
                    <header>
                        <div className="logo">
                            <img src={imageSrc} alt="Logo" style={{ width: '200px', height: '150px' }} /> 
                        </div>
                        <div className="company" >
                            <h2 style={{ textAlign: "left" }} >{Empresa.descripcion}</h2>
                            <p>RNC: {Empresa.rnc}</p>
                            <p>{Empresa.direccion}</p>
                            <p>Tel: {Empresa.telefono} · Email: {Empresa.email}</p>
                        </div>
                        <div className="meta">
                            <h2>Factura</h2>
                         
                            <div><b>Impreso</b></div>
                            <div><b>Fecha:</b>{moment(new Date).format("DD/MM/YYYY")}</div>
                            <div><b>Hora:</b>{moment(new Date).format("HH:mm:SS")}</div>
                         

                        </div>
                    </header>

                    <div className="grid">
                        <div className="card">
                            <h3>Cliente</h3>
                            <div><strong>{Listado.nombreCliente}</strong></div>
                            <div>RNC/Cédula: {Listado.rnc}</div>
                            <div>Contacto: </div>
                            <div>Tel/Email: {Listado.telefono + " / "+ ListadoClientes.correo}</div>
                            <div>Dirección: {ListadoClientes.direccion}</div>
                            <div>Vendedor: </div>
                        </div>
                        <div className="card">
                            <h3>Factura</h3>
                            <div>{SN}</div>
                            <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                            <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                            <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                            <div><b>Orden No:</b>{Listado.facturaID}</div>
                            <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>
                            <div><b>Condición de pago:</b>{Listado.credito == 0 ? 'Contado' : 'Credito'}</div>

                          
                            <div><b>Moneda:</b>{Listado.moneda } </div>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: 40 }}>#</th>
                                <th>Descripción</th>
                                <th className="right" style={{ width: 90 }}>Cant.</th>
                                <th style={{ width: 90 }}>Unidad</th>
                                <th className="right" style={{ width: 120 }}>Precio Unit.</th>
                                <th className="right" style={{ width: 90 }}>% Desc.</th>
                                <th className="right" style={{ width: 130 }}>Importe</th>
                            </tr>
                        </thead>
                        <tbody>
                          
                            {ListadoLineas.map((it, idx) => {
                                const qty = Number(it.cantidad || 0);
                                const price = Number(it.precio || 0);
                                const disc = Number(it.discountPercent || 0);
                                const line = qty * price;
                                const lineDisc = (line * disc) / 100;
                                const totalLine = line - lineDisc;
                                return (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{it.descripcionArticulo}</td>
                                        <td className="right">{qty}</td>
                                        <td>{it.unit || ""}</td>
                                        <td className="right">{money(price)}</td>
                                        <td className="right">{disc}</td>
                                        <td className="right">{money(totalLine)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div className="totals">
                        <div></div>
                        <div className="summary">
                        
                            <div className="" style={{ width: "30%" }} hidden={!Empresa.itbisIncluido} >
                                <div hidden={Listado.tipoComprobante != 1} className="row"><div>Subtotal</div><div><strong>{money((Listado.subTotal + Listado.totalITBIS))}</strong></div></div>
                            <div hidden={Listado.tipoComprobante == 1}  className="row"><div>Subtotal</div><div><strong>{money(Listado.subTotal)}</strong></div></div>
                                <div className="row"><div>Descuento</div><div>{money(Listado.totalDescuento)}</div></div>
                                <div className="row" hidden={Listado.tipoComprobante == 1}><div>ITBIS ({percentLabel})</div><div>{money(Listado.totalITBIS)}</div></div>

                                    <div  className="row total"><div>Total</div><div>{money(Listado.totalPago)}</div>

                                    </div>
                        
                      

                              

                            </div> 
                            <div className="" style={{ width: "30%" }} hidden={Empresa.itbisIncluido} >

                                <div hidden={Listado.tipoComprobante != 1} className="row"><div>Subtotal</div><div><strong>{money((Listado.subTotal + Listado.totalITBIS))}</strong></div></div>
                                <div hidden={Listado.tipoComprobante == 1} className="row"><div>Subtotal</div><div><strong>{money(Listado.subTotal)}</strong></div></div>
                                <div className="row"><div>Descuento</div><div>{money(Listado.totalDescuento)}</div></div>
                                <div className="row" hidden={Listado.tipoComprobante == 1}><div>ITBIS ({percentLabel})</div><div>{money(Listado.totalITBIS)}</div></div>
                                <div className="row total"><div>Total</div><div>{money(Listado.totalPago)}</div></div>


                            </div>

                        </div>
                    </div>

                    <div className="notes">
                        <strong>Notas / Condiciones:</strong>
                       {Listado.comentario}
                    </div>

                    <div className="sign">
                        <div style={{
                            //borderTop: '2px solid',
                            width: '30%',
                            textAlign: 'center'
                        }}>
                            <img className="card-img-top" src="./imagen/LogoEmpresa/Firma.png" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />
                            Firma y sello de {company.name}
                        </div>
                    
                        <div className="line">Aceptación del cliente</div>
                    </div>
                    </>
                    )}
                    {printMode === 'pos' && (
                        <div className="ticket-page">
                            <div className="ticket-head">
                                <img src={imageSrc} alt="Logo" className="ticket-logo" />
                                <div className="ticket-company">{Empresa.descripcion}</div>
                                <div>RNC: {Empresa.rnc}</div>
                                <div>{Empresa.direccion}</div>
                                <div>Tel: {Empresa.telefono}</div>
                            </div>
                            <div><b>Factura:</b> {Listado.ncf}</div>
                            <div><b>Fecha:</b> {moment(Listado.fecha).format("DD/MM/YYYY HH:mm")}</div>
                            <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                            <div><b>RNC/Ced:</b> {Listado.rnc}</div>
                            <table className="ticket-items">
                                <thead>
                                    <tr>
                                        <th>Desc</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ListadoLineas.map((x, idx) => (
                                        <tr key={idx}>
                                            <td>{x.cantidad} x {x.descripcionArticulo}</td>
                                            <td>{money((x.totalLinea || (x.cantidad * x.precio || 0)))}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="ticket-totals">
                                <div className="ticket-total-line"><span>Subtotal</span><span>{money(Listado.subTotal)}</span></div>
                                <div className="ticket-total-line"><span>Descuento</span><span>{money(Listado.totalDescuento)}</span></div>
                                <div className="ticket-total-line"><span>ITBIS</span><span>{money(Listado.totalITBIS)}</span></div>
                                <div className="ticket-total-line ticket-total-final"><span>Total</span><span>{money(Listado.totalPago)}</span></div>
                            </div>
                            <div className="ticket-footer">
                                <div>Le atendio: {Leatendio}</div>
                                <div>Gracias por su compra</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        
      
            <div hidden={true} >
    
             
                <div class="containerP" hidden={impresion} onClick={() => Imprimir()} >
              
                        <div style={{ textAlign: "center" }}><h4>{Empresa.descripcion}</h4>
                    <div style={{  fontSize: "16px" }} >  <div>{Empresa.direccion}</div>
                        <div  > RNC :{Empresa.rnc}</div>
                        <b>Tel:</b>{Empresa.telefono}  <b>Correo: </b>{Empresa.email}</div>
                      </div>  <br></br>
                <div style={{ textAlign: "left", fontSize: "16px" }}>
                        <div>{SN}</div>
                        <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                        <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                        <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                        <div><b>Orden No:</b>{Listado.facturaID}</div>
                        <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>

                        <div hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc}</div>
                        <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                    <div><b>Telefono:</b> {Listado.telefono} <b>Email: </b>{ListadoClientes.correo}</div>
                        <div><b>Dirección:</b> {ListadoClientes.direccion}</div>
                      



                    </div>
                
               
                <div style={{ textAlign: "left", fontSize: "10px" }} >
                        <table class="tablep">

                            <tr style={{ border: "2px solid" }}>
                                <th>Descripción</th>
                                <th>Cant</th>
                                <th>Total</th>
                            </tr>

                            {ListadoLineas.map(x => (
                                <tr style={{ fontFamily: "system-ui"} }>
                                    <td style={{width:"50%" }}>{x.descripcionArticulo}
                                        {/*<div> Precio: {(x.precio).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>*/}
                                    </td>
                                    <td>{x.cantidad}</td>
                                    <td>{(x.totalLinea ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                </tr>

                            ))}
                        </table>
                    </div>
                    <div class="footer">
                        <div class=""  >
{/*hidden={Listado.tipoComprobante != 1}*/}
                        <div ><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal+ Listado.totalITBIS })}</div>
                            <div hidden={true}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                            <div hidden={true} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                    </div>
                        <br></br>
                    <p>Le Atendio: {Leatendio}</p>
                    <p>Gracias por visitarnos</p>
                    <br></br>
                    </div>
                </div>
      

                <div class="letra" hidden={!impresion} hidden onClick={() => Imprimir()}>

              
                
                        <div class="printArea" style={{ backgroundColor: "none"} }>
                    <div class="page">

                     
                        <html lang="en">
                        
                                    <body>

                                        <div class="container" >
                                        {/*<div style={{ textAlign: "right", padding: "0px" }} hidden>   <h5>  COPIA DE FACTURA</h5></div>*/}
                                        <div class="header" style={{ marginTop: "10%"} }>
                               
                                            <table className="tableh" style={{ textAlign: "left" }} >
                                            <tr >
                                                <td style={ {width:"20%", border: "0px"}} >
                                            <img class="card-img-top" src="./imagen/LogoEmpresa/Logo.png" style={{ width: '200px', height: '150px' }} />
                                                </td>  
                                                    <td style={{ border: "0px", textAlign: "left" }}>
                                                    <h2>{Empresa.descripcion}</h2>
                                                   <div>{Empresa.direccion}</div> 
                                                    <div hidden={Listado.tipoComprobante ==1 } > RNC :{Empresa.rnc}</div>
                                                    Tel:{Empresa.telefono} Correo: {Empresa.email}

                                                   
                                                </td>
                                            </tr>
                                        </table>
                                     
                                      
                                            </div>

                                            <div class="bill-info">
                                                <div>
                                                    <h2>Cliente:</h2>
                                            <p hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc }</p>
                                        <div><b>Nombre:</b> {Listado.nombreCliente }</div>
                                    <div><b>Telefono:</b> {Listado.telefono }</div>
                                <div><b>Dirección:</b> {ListadoClientes.direccion }</div>
                            <div><b>Email: </b>{ListadoClientes.correo}</div>
                                          
                                                </div>
                                                <div>
                                                    <h2>Factura:</h2>
                                            <div>{SN}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                    <div><b>Orden No:</b>{Listado.facturaID}</div>
                                            <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>
                                            <div><b>Condición:</b>{Listado.credito == 0 ? 'Contado' : 'Credito' }</div>
                                        </div>
                                            </div>
                                    <div style={{ minHeight: '6.02in'} }>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Descripción</th>
                                                        <th>Cantidad</th>
                                                        <th>Precio unitario</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                        <tbody>
                                            {ListadoLineas.map(x =>(
                                                    <tr>
                                                    <td>{x.descripcionArticulo }</td>
                                                    <td>{x.cantidad }</td>
                                                    <td >${x.precio.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    <td >${(x.precio * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                   
                                                    {/*<td hidden={Empresa.itbisIncluido}>${(x.precio + x.itbis).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>*/}
                                                    {/*<td hidden={Empresa.itbisIncluido}>${((x.precio + x.itbis) * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>*/}
                                                    </tr>
                                            
                                           ) )}
                                                </tbody>
                                        </table>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div class="bill-info">
                                        <div style={{ width: "70%" }} >
                                        <b> Comentario:</b> {Listado.comentario }
                                        </div>
                                        <div style={{ width: "10%" }}></div>
                                        <div class="" style={{ width: "20%" }} hidden={!Empresa.itbisIncluido } >
                                         
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                        <div class="" style={{ width: "20%" }} hidden={Empresa.itbisIncluido} >
                                          
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({currency: "USD",value: Listado.subTotal})}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br> 
                                    <div class="bill-info">
                                       

                                        <div style={{
                                            //borderTop: '2px solid',
                                            width: '30%',
                                            textAlign: 'center'} }>
                                                <img class="card-img-top" src="./imagen/LogoEmpresa/Firma.png" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />
                                         Realizado Por
                                        </div>
                                     
                                        <div style={{
                                           // borderTop: '2px solid',
                                            width: '30%', height: '100px',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ width: '200px', height: '90px', borderBottom: '2px solid' }}></div>
                                       Recibido Por


                                        </div>
                                    </div>


                                        </div>

                                    </body>
                                </html>

                       

                    </div>

                    </div>

                
                 
                </div>
                </div>
                {menuPosition && (
                    <ul
                        style={{
                            position: 'absolute',
                            top: menuPosition.y,
                            left: menuPosition.x,
                            backgroundColor: 'white',
                            border: '1px solid gray',
                            listStyle: 'none',
                            padding: '10px',
                            margin: 0,
                        }}
                        onClick={handleCloseMenu} // Cierra el menú al hacer clic.
                    >
                        <li>OPCIONES DE IMPRESION</li>
                        <li><wbr/></li>
                        <li><a className="btn" onClick={() => Imprimir()}> IMPRIMIR</a></li>
                        <li><a className="btn" onClick={() => setPrintMode(printMode === 'a4' ? 'pos' : 'a4')}> CAMBIAR A {printMode === 'a4' ? 'PUNTO DE VENTA' : 'A4'}</a></li>

                    </ul>
                )}
            </div>
        </>
        )

}
export default ImpresionFactura;
